export const KeyCache = {
  INFO: 'INFO',
  MYCOUPON: 'my-coupon',
  GOLD_ONBOARD: 'gold-onboard',
}
